import { render, staticRenderFns } from "./ImageAnnotator.vue?vue&type=template&id=0f2afd7d&scoped=true"
import script from "./ImageAnnotator.vue?vue&type=script&lang=ts"
export * from "./ImageAnnotator.vue?vue&type=script&lang=ts"
import style0 from "./ImageAnnotator.vue?vue&type=style&index=0&id=0f2afd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2afd7d",
  null
  
)

export default component.exports